import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("lwa_admin_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("lwa_admin_email") || "");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!token) {
      setChecking(false);
      return;
    }
    api
      .get("/admin/me")
      .then((r) => setEmail(r.data.email))
      .catch(() => logout())
      .finally(() => setChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (em, password) => {
    const { data } = await api.post("/admin/login", { email: em, password });
    localStorage.setItem("lwa_admin_token", data.token);
    localStorage.setItem("lwa_admin_email", data.email);
    setToken(data.token);
    setEmail(data.email);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("lwa_admin_token");
    localStorage.removeItem("lwa_admin_email");
    setToken(null);
    setEmail("");
  };

  return (
    <AdminAuthContext.Provider value={{ token, email, checking, login, logout, isAuthed: !!token }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
